import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/property-fees`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/property-fees/${id}?include=property`, options)
    .then((response) => {
      let propertyFee = jsona.deserialize(response.data);
      delete propertyFee.links;
      return propertyFee;
    });
}

function add(propertyFee) {
  const payload = jsona.serialize({
    stuff: propertyFee,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/property-fees?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function applyFee(propertyFee) {
  const payload = jsona.serialize({
    stuff: propertyFee,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/property-fees/apply-fee?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(propertyFee) {
  const payload = jsona.serialize({
    stuff: propertyFee,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/property-fees/${propertyFee.id}?include=`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/property-fees/${id}`, options);
}
export default {
  list,
  get,
  add,
  applyFee,
  update,
  destroy,
};
